import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { IconButton, Tooltip } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import cx from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { maxExtendRightPanel, maxReduceRightPanel } from 'FRONTEND/reducers/rightPanelSlice';
import i18n from 'FRONTEND/utils/i18n';
import { SCREEN_XS_PX } from 'LEGACY/constants';

const ExtendButton = () => {
  /**
   * Button to extend or reduce RTC.
   */
  const dispatch = useDispatch();
  const isMaxExtended = useSelector((state) => state.rightPanel.isMaxExtended);
  const isExtended = useSelector((state) => state.rightPanel.isExtended);
  const isShown = useSelector((state) => state.rightPanel.isShown);

  const screenXS = useMediaQuery(`(max-width:${SCREEN_XS_PX})`, { noSsr: true });

  const isSidePanelMounted = useSelector(state => state.sidePanel.isMounted);
  const isSidePanelExtended = useSelector(state => state.sidePanel.isExtended);
  const extenderClasses = cx('rtcIframe-extender', {
    'rtcIframe-extender_extended': isMaxExtended,
    'rtcIframe-extender_withSidePanel': isSidePanelMounted,
    'rtcIframe-extender_withExtendedSidePanel': isSidePanelMounted && isSidePanelExtended,
  });

  const handleButtonClick = () => {
    if (isMaxExtended) {
      dispatch(maxReduceRightPanel());
    } else {
      dispatch(maxExtendRightPanel());
    }
  };

  return isExtended && !screenXS && isShown ? (
    <div className={extenderClasses}>
      <Tooltip title={isMaxExtended ? i18n._('Reduce chat window') : i18n._('Extend chat window')} placement='top'>
        <IconButton onClick={handleButtonClick} className='iconButton-extender' size='large'>
          {isMaxExtended ? <KeyboardDoubleArrowRightIcon /> : <KeyboardDoubleArrowLeftIcon />}
        </IconButton>
      </Tooltip>
    </div>
  ) : null;
};

export default ExtendButton;
